export const regimes = [
  { id: '1', name: 'Régimen Común' },
  { id: '2', name: 'Régimen Simplificado' },
  { id: '3', name: 'Gran Contribuyente' },
  { id: '4', name: 'Régimen Especial' }
];